<template>
  <Layout :instruction="instruction">
    <template v-slot:title>
      <div>
        <span v-if="!isEditMode">Create new</span> Single Choice instruction
      </div>
    </template>
    <template v-slot:content>
      <div class="content-wrapper">
        <b-field class="full-width">
          <b-input
            type="textarea"
            size="is-small"
            v-model="question"
            :disabled="loading"
          ></b-input>
        </b-field>
        <div class="options">
          <div
            v-for="(option, index) in options"
            :key="index"
            class="option-item"
          >
            {{ index + 1 + '.' }}
            <b-field>
              <b-input
                v-if="option.other"
                placeholder="Other"
                readonly
              ></b-input>

              <b-input
                v-else
                v-model="option.defaultMC"
                placeholder="Enter an option"
              ></b-input>
              <a class="delete-option" @click="removeOption(index)">✖</a>
            </b-field>
          </div>
          <b-button type="is-primary" @click="addOption"
            >+ Add an option</b-button
          >
          <b-button
            type="is-primary"
            @click="addOtherOption"
            :disabled="options.some((opt) => opt.other)"
            >+ Add "Other" option</b-button
          >
        </div>
        <b-field>
          <b-checkbox v-model="pictureMandatory">
            Picture taken is mandatory.</b-checkbox
          >
        </b-field>
      </div>
    </template>
    <template v-slot:reference-image>
      <ReferenceImage :instructionProps="instruction" ref="refImage" />
    </template>
    <template v-slot:footer>
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>
      <b-button
        :disabled="!instruction"
        type="is-danger"
        @click="$emit('onDelete')"
        >Delete</b-button
      >
      <b-button type="is-link" @click="$emit('onCancel')">Cancel</b-button>
      <b-button
        v-if="!instruction"
        type="is-success"
        :disabled="loading"
        @click="onSave"
        :loading="loadingButton"
        >Save</b-button
      >
      <b-button
        v-if="instruction"
        type="is-success"
        @click="onUpdate"
        :loading="loadingButton"
        >Update</b-button
      >
    </template>
  </Layout>
</template>

<script>
import Layout from './layout';
import ReferenceImage from '../ReferenceImage';
import { GET_LOADING_STATE } from '../../../../../store/loading/getters/getterTypes';
import KeyHandlerMixin from '../../../../../mixins/KeyHandlerMixin';

export default {
  name: 'single-choice',
  components: {
    Layout,
    ReferenceImage,
  },
  mixins: [KeyHandlerMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    instruction: {
      type: Object,
      default: null,
    },
  },
  computed: {
    loading() {
      return this.$store.getters[GET_LOADING_STATE];
    },
    // sortedOptions() {
    //   return this.options.sort((a, b) => (a.other ? 1 : 0) - (b.other ? 1 : 0));
    // },
  },
  mounted() {
    if (this.instruction) {
      const { question, multipleChoices, isPictureMandatory } =
        this.instruction;
      this.question = question;
      this.options = multipleChoices
        ? JSON.parse(JSON.stringify(multipleChoices))
        : [{ checked: false }];
      this.pictureMandatory = isPictureMandatory;
    }

    if (this.instruction) {
      this.setKeyHandlerCallback('update', this.onUpdate);
    } else {
      this.setKeyHandlerCallback('save', this.onSave);
    }
  },
  data() {
    return {
      question: '',
      options: [{ checked: false }],
      pictureMandatory: false,
      loadingButton: false,
    };
  },
  methods: {
    addOption() {
      this.options.push({ checked: false });
      this.sortOptions();
    },
    addOtherOption() {
      if (!this.options.find((opt) => opt.other)) {
        this.options.push({ other: true, defaultMC: '', checked: false });
      }
      this.sortOptions();
    },
    sortOptions() {
      this.options.sort((a, b) => (a.other ? 1 : 0) - (b.other ? 1 : 0));
    },
    removeOption(index) {
      this.options.splice(index, 1);
    },
    onSave() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onSave', {
        question: this.question,
        multipleChoices: this.options,
        isPictureMandatory: this.pictureMandatory,
        type: 'singlechoice',
        file,
        useImageReference,
      });
    },
    onUpdate() {
      const file = this.$refs.refImage?.file;
      const useImageReference = this.$refs.refImage?.useImageReference;
      this.loadingButton = true;
      this.$emit('onUpdate', {
        _id: this.instruction._id,
        ...this.instruction,
        question: this.question,
        multipleChoices: this.options,
        isPictureMandatory: this.pictureMandatory,
        type: 'singlechoice',
        file,
        useImageReference,
      });
    },
  },
};
</script>

<style scoped>
button {
  flex: 1;
}

.content-wrapper {
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 40px;
}

.options {
  width: 100%;
  gap: 10px;
  display: flex;
  flex-direction: column;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.delete-option {
  margin-left: 10px;
  cursor: pointer;
  color: red;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.full-width {
  width: 100%;
}
</style>
